import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Injectable } from '@angular/core';
import { RecordingService } from './recording-service.interface';
import { RecordingStates } from './recording-states';
import { WebRTCAdaptor } from '../../../assets/js/media/webrtc_adaptor.js';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AntmediaRecorderService extends RecordingService {
  adaptor: any;
  private streamAudioDevices = new BehaviorSubject([]);
  private firstInit = true;

  private WEB_SOCKET_URL = 'wss://audio.subastando.co:5443/WebRTCAppEE/websocket';
  private PEER_CONNECTION_CONFIG = {
    iceServers: [
      {
        urls: 'stun:stun1.l.google.com:19302',
      },
    ],
  };

  constructor(args: any) {
    super(args);
  }

  preInit() {
    this.init();
  }

  init() {
    return new Promise<void>((res, rej) => {
      console.log('Antmedia init');
      this.adaptor = new WebRTCAdaptor({
        websocket_url: this.WEB_SOCKET_URL,
        mediaConstraints: {
          video: false,
          audio: true,
        },
        peerconnection_config: this.PEER_CONNECTION_CONFIG,
        sdp_constraints: {
          OfferToReceiveAudio: false,
          OfferToReceiveVideo: false,
        },
        localVideoId: 'audioSource',
        debug: true,
        callback: function (info, description) {
          console.log('callback called info: ' + info + ' desc: ' + description);

          if (info == 'initialized') {
            console.log('initialized');
            setTimeout(() => {
              res();
            }, 1000);
          } else if (info == 'publish_started') {
            //stream is being published
            console.log('publish started');
          } else if (info == 'publish_finished') {
            console.log('publish finished');
            //stream is being finished
          } else if (info == 'closed') {
            //console.log("Connection closed");
            if (typeof description != 'undefined') {
              console.log('Connecton closed: ' + JSON.stringify(description));
            }
          }
        },
        callbackError: function (error, message) {
          //some of the possible errors, NotFoundError, SecurityError,PermissionDeniedError
          console.log('error callback: ' + JSON.stringify(error));
          var errorMessage = JSON.stringify(error);
          if (typeof message != 'undefined') {
            errorMessage = message;
          }
          var errorMessage = JSON.stringify(error);
          if (error.indexOf('NotFoundError') != -1) {
            errorMessage = 'Camera or Mic are not found or not allowed in your device';
          } else if (error.indexOf('NotReadableError') != -1 || error.indexOf('TrackStartError') != -1) {
            errorMessage = 'Camera or Mic is being used by some other process that does not let read the devices';
          } else if (
            error.indexOf('OverconstrainedError') != -1 ||
            error.indexOf('ConstraintNotSatisfiedError') != -1
          ) {
            errorMessage =
              'There is no device found that fits your video and audio constraints. You may change video and audio constraints';
          } else if (error.indexOf('NotAllowedError') != -1 || error.indexOf('PermissionDeniedError') != -1) {
            errorMessage = 'You are not allowed to access camera and mic.';
          } else if (error.indexOf('TypeError') != -1) {
            errorMessage = 'Video/Audio is required';
          }

          rej(errorMessage);
        },
      });
    });
  }

  async start(microphoneId: string): Promise<void> {
    console.log('AntMedia Started with micro: ' + microphoneId + ' and channel ' + this.args.channelName);
    this.adaptor.switchAudioInputSource(this.args.channelName, microphoneId);
    this.adaptor.publish(this.args.channelName);
    this.streamStateSubject.next(RecordingStates.PLAYING);
    this.isRecording = true;
  }

  play() {
    console.log('AntMedia played');
    this.adaptor.unmuteLocalMic();
    this.adaptor.sendData(this.args.channelName, 'PEER_AUDIO_UNMUTED');
    this.streamStateSubject.next(RecordingStates.PLAYING);
  }

  pause() {
    console.log('AntMedia paused');
    this.adaptor.muteLocalMic();
    this.adaptor.sendData(this.args.channelName, 'PEER_AUDIO_MUTED');
    this.streamStateSubject.next(RecordingStates.PAUSED);
  }

  stop() {
    if (!this.isRecording) {
      return;
    }

    console.log('AntMedia stopped');
    this.adaptor.sendData(this.args.channelName, 'REMOTE_UNSUBSCRIBED');
    this.adaptor.stop(this.args.channelName);
    this.adaptor.closeStream();
    this.adaptor.closeWebSocket(this.args.channelName);
    this.streamStateSubject.next(RecordingStates.STOPED);
    this.isRecording = false;
  }

  getInputDevices() {
    console.log('AntMedia input devices requested');
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const objDevices = {};
      const finalDevices = [];
      for (const device of devices) {
        if (device.kind !== 'audioinput' || device.label.length == 0) {
          continue;
        }
        if (objDevices[device.groupId] !== undefined && objDevices[device.groupId].deviceId === 'default') {
          continue;
        }
        objDevices[device.groupId] = device;
      }
      const keys = Object.keys(objDevices);
      for (const key of keys) {
        finalDevices.push(objDevices[key]);
      }
      this.streamAudioDevices.next(finalDevices);
    });

    return this.streamAudioDevices.asObservable();
  }
}
